import { createSelector } from 'reselect';

const selectAdminLevelFour = (state: any) => state.AdminLevelFour;


export const selectAdminLevelFourCurrentItem = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.current);

export const selectAdminLevelFourListItems = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAdminLevelFourListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAdminLevelFourQueryItems = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.query);

export const selectAdminLevelFourCreatedItem = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.create);

export const selectAdminLevelFourUpdatedItem = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.update);

export const selectAdminLevelFourReadItem = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.read);

export const selectAdminLevelFourDeletedItem = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.delete);

export const selectAdminLevelFourSearchedItems = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.search);

export const selectAdminLevelFourItemsCount = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.count);

export const selectAdminLevelFourItemsFilter = createSelector([selectAdminLevelFour], (AdminLevelFour) => AdminLevelFour.filter);